/**
 * Quest page photo blocks in R2 (same COVERS bucket as covers and spot thumbs).
 */
import type { CoverExt } from "./quest-cover.ts";
import { COVER_CONTENT_TYPE } from "./quest-cover.ts";

const FILE = /^([0-9a-f]{32})\.(webp|jpg)$/;

/** R2 key: page-photos/<missionId>/<slot>/<hash>.webp */
export function pagePhotoKey(missionId: string, slot: number, hash: string, ext: CoverExt): string {
  return `page-photos/${missionId}/${slot}/${hash}.${ext}`;
}

export function pagePhotoUrl(missionId: string, slot: number, key: string | null | undefined): string | null {
  if (!key) return null;
  const prefix = `page-photos/${missionId}/${slot}/`;
  if (!key.startsWith(prefix)) return null;
  const file = key.slice(prefix.length);
  if (!FILE.test(file)) return null;
  return `/api/page-photos/${encodeURIComponent(missionId)}/${slot}/${file}`;
}

export function parsePagePhotoFile(file: string): { hash: string; ext: CoverExt } | null {
  const m = FILE.exec(file);
  return m ? { hash: m[1]!, ext: m[2] as CoverExt } : null;
}

export { COVER_CONTENT_TYPE as PAGE_PHOTO_CONTENT_TYPE };

export const MAX_PAGE_PHOTOS = 32;
export const MAX_PAGE_PHOTO_CAPTION = 500;
